// @ts-ignore
import { Component, OnInit, ViewChildren, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Zone } from '../../../../classes/Zone';
import { Light } from '../../../../classes/Light';
import { Images } from '../../../../classes/Images';
import { Calculation } from '../../../../classes/Calculations';
import { ModelService } from '../../../services/model.service';
import { LoginService } from '../../../services/login.service';
import { GlobalService } from '../../../services/global.service';
import { WindowRef } from '../../../../classes/windowRef';
import { DomSanitizer } from '@angular/platform-browser';
import { COLORS } from '../../../data/colors';
import swal from 'sweetalert2';

import * as $ from 'jquery';

@Component({
  host: {
    '( document: scroll )': 'onScrollDocument( $event )'
  },
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrls: ['./project.component.scss']
})
export class ProjectComponent implements OnInit {
  @ViewChildren( 'zones' ) zonesElements;

  // ID of project
  id: number;

  _colorsList = COLORS;

  // Prevent loading jumping
  contentVisible: boolean = false;

  // Popups
  newLightPopupVisible: boolean = false;
  newZonePopupVisible: boolean = false;
  cloneZonePopupVisible: boolean = false;
  splitProductPopupVisible: boolean = false;

  clonedZoneID: any = '';
  clonedZoneName: string = '';

  // New objects
  newZone: Zone = new Zone( );
  newLight: Light = new Light( );
  calculation: Calculation = new Calculation( );

  proposalEmail: any = {};

  // Active tab
  activeTab: string = 'product';

  innerTabs = {
    invoice: 'detail'
  };

  // Permissions control
  availableRoles: string[] = [ 'admin', 'sales', 'manager', 'referrer' ];
  isAvailable: boolean = true;

  // For labels
  entities = {
    bulb:       'Lamp',
    fixture:    'Fixture',
    accessory:  'Accessory',
    housing:    'Housing'
  }

  // Additional info on overlay
  additionalOverlayFields = { }

  // Lists for overlay
  productTypesList  = [];
  baseTypesList     = [];
  SKUsList  = [];

  // Checking if order was saved at least once
  has_order: boolean = false;
  was_saved: boolean = false;

  // Checking if we are editing light
  isEdit: boolean = false;
  isProductFieldDisabled: boolean = true;
  isRequiredNotesField: boolean = true;
  isNotesWasEdited: boolean = false;

  // Control of changes Invoice
  isHaveChangesInvoice: boolean = false;
  isHaveChangesBitcodes: boolean = false;

  // Control for overlay additional fields
  showAdditionalFields: boolean = false;

  // Note for order
  orderNote = '';

  // Order fields
  paymentMethod: string;
  depositAmount: number = 0;
  depositAmountNumber: string = '0.00';
  depositAmountAdd: any = '';
  depositOverride: any = '';
  order_id = 0;

  // Notes for order
  notes = [];
  hasNotes: boolean = false;

  // Filters for overlay
  filters: any = {
    available_entity: '',
    need_proposed: false,
    compare:      false,
    link:         false,
    type:         '',
    entity:       '',
    productType:  '',
    baseType:     '',
    description:  '',
    zone:         '',
    excludeID:    []
  };
  
  // All default info
  projectInfo: any = {
    video_before: []
  };
  projectName: string = '';
  projectZones: any[] = [];
  options: any[] = [];
  
  productList: any[] = [];

  permission: string = 'editable';

  // Heights calculation for graphs
  graphHeights: any[] = [
    [0, 0],
    [0, 0]
  ];

  datepickerOptions = {
    hideIcon: true,
    format: 'mm/dd/yyyy',
    enableOnReadonly: true
  };

  purchaseInfo: any = {
    manufacturers: []
  };

  is_saved_form: boolean = true;

  invoiceMailInfo: any = {
    type:         'invoice',
    project_id:   0,
    mailFrom:     '',
    mailTo:       '',
    cc:           '',
    subject:      '',
    message:      '',
    is_mailed:    false,
    is_generated: true
  };

  viaQuickbooks: boolean = false;

  withLinked: boolean = true;

  proposedProductsOld: any[] = [];
  proposedProductsToSave: any[] = [];

  controllPurchaseStatus: string = '';
  purchaseOrderNumber: any = 0;
  selectedPurchaseManufacturer: any = '';
  defaultEmail: string = 'lumigenie@gmail.com';
  purchaseDate: any = new Date( );
  purchaseDate_formatted: string = '';
  depositAmountOld: any;
  paymentMethodOld: any = '';

  prepopulatedPurchaseShipping: string = '';
  prepopulatePurchaseShipping: boolean = false;

  rebatesInfo: any[] = [];

  popupMinimized: boolean = false;

  _scrollTopTimer:any = null;
  initialScrollingTriggered: boolean = false;

  bindedColors = [];

  editLightHasMainProduct: boolean = false;

  // For main checkbox about moving products and object of moved products
  choseForMoveProduct: boolean = false;
  productsToMove: any[] = [];
  hasProductsToMove: boolean = false;
  
  choseForRemoveProducts: boolean = false;
  productsToRemove: any[] = [];

  // Split products
  splitProductZoneName:            string = '';
  splitProductZoneID:              number = 0;
  splitProductQuantity:            number;
  splitProductExistingQuantity:    number;
  splitProductQuantityMax:         number = 0;
  splitProductExistingQuantityMax: number = 0;
  splitLightLinked:                boolean = false;
  splitLightIsLinkedTo:            boolean = false;
  splitLinkedToProposed:           any[] = [];
  checkedProductToMove:            number;
  checkedProductToMoveDescription: string = '';


  // Custom groups
  choseForCreateGroup:      boolean = false;
  hasLightsForCustomGroup:  boolean = false;
  customGroup:              any = {
    currentZone: 0,
    group: [],
    hasProposed: false
  };

  showInProposal: any = {
      A: true,
      B: true,
      C: true
  };

  /*showSavings: any = {
    A: false,
    B: false,
    C: false
  };*/

  applyRebate: boolean = false;
  cloneLineItems: boolean = false;

  oldLightingSchedule: string = '';
  excludeLightingSchedule: any[] = [];
  currentLinkedProducts: any[] = [];

  manuallyLinkedLabel: string = 'Manually Linked';
  autoLinkedLabel: string = 'Auto Linked';

  customZones: any[] = [];

  // Schedules
  defaultSchedules: any = {
    dailyUse: '',
    weeklyUse: '',
    yearlyUse: ''
  };

  isLinkedCurrentProduct: boolean = false;

  linkedProductsDescriptions: string[] = [];

  _newLightVideo: any;


  // Clone project
  cloneProjectPopupVisible: boolean = false;
  cloneProjectName: string = '';


  triggerInitialScroll: boolean = true;


  purchaseOrderRates: any[] = [];
  dumpedPurchaseOrderRates: any[] = [];
  saveRateButtonDisabled: boolean = true;

  currentShippingAddress: string = '';

  daysDueSelect: any = '';
  daysDueOld: string;
  daysDue: string;

  lightsCount: number = 0;

  // Option, browsed by user
  selectedOption: string = 'A';

  // Option for invoice
  mainSelectedOption: string = 'A';

  // Select params

  selectParams: any = {
    daysDue: {
      id: 'selectDaysDue',
      isRequired: true,
      change: ( event ) => {
        this.changeDaysDue( event.value );
      },
      options: [ 
        { text: '', value: '' },
        { text: '15', value: '15' },
        { text: '30', value: '30' },
        { text: '60', value: '60' },
        { text: 'Other', value: 'other' }
      ],
      search: false
    },

    overlayEntity: {
      id: 'inputLightProductEntity',
      isRequired: true,
      change: ( event ) => {
        this.changeLightProperty( 'entity', event.value );
      },
      options: [ { text: '', value: '' } ],
      search: false
    },


    overlayProductType: {
      id: 'inputProductType',
      isRequired: true,
      isDisabled: this.isProductFieldDisabled,
      change: ( event ) => {
        // this.filters.productType = event.value;
        this.changeLightProperty( 'productType', event.value );
      },
      options: [ { text: '', value: '' } ]
    },


    overlayBaseType: {
      id: 'inputBaseType',
      isDisabled: this.isProductFieldDisabled,
      isRequired: true,
      change: ( event ) => {
        // this.filters.baseType = event.value;
        this.changeLightProperty( 'baseType', event.value );
      },
      options: [ { text: '', value: '' } ]
    },


    overlayDescription: {
      id: 'inputLightProductEntity',
      isRequired: true,
      isDisabled: this.isProductFieldDisabled,
      change: ( event ) => {
        this.filters.description = event.value;
        this.setNewLightEntityID(  event.value );
        this.changeLightProperty( 'description', event.value );
      },
      options: [ { text: '', value: '' } ]
    },


    purchaseManufacturer: {
      id: 'select__purchase-manufacturer',
      isRequired: false,
      isDisabled: !this.invoiceMailInfo.is_generated || !this.projectInfo.depositAmount || this.projectInfo.depositAmount == '0.00',
      change: ( event ) => {
        this.selectedPurchaseManufacturer = event.value;
        this.changePurchaseManufacturer( event.value );
      },
      options: [ { text: '', value: '' } ]
    },


    productsOptions: {

      id: 'selectProductsOption',
      isRequired: false,
      change: ( event ) => {
        this.mainSelectedOption = event.value;

        this.model.saveActiveOption( this.id, this.mainSelectedOption, ( response ) => {
          let _answer = response.json( ).answer;
          if ( _answer == 'success' ) {
            this.successCallback( 'Option for invoice was changed successfully' );
          } else this.global.defaultErrorCallback( _answer, false );
        });
      },
      options: [],
      search: false
    }

  };

  _videos = [ ];

  SKUSearch: string = '';
  descriptionSearch: string = '';
  searchBySKU: boolean = true;

  projectHasProducts = false;

  constructor ( 
    private route: ActivatedRoute, 
    public global: GlobalService,
    private model: ModelService,
    private sanitizer: DomSanitizer,
    private winRef: WindowRef,
    public loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Project' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
    if ( this.loginService.userInfo.role == 'referrer' ) this.activeTab = 'invoice';
  }

  changeShowInProposal(option, show: any){

      this.model.saveShowInProposalInfo( this.id, option, show, ( response ) => {
          let _answer = response.json( ).answer;
          if ( _answer == 'success' ) {
              this.successCallback( 'Your selection has been saved successfully' );
          } else this.global.defaultErrorCallback( _answer, false );
      });
  }

  changeViaQuickbooks( viaQuickbooks ){

    this.model.saveViaQuickbooks( this.id, viaQuickbooks, ( response ) => {
      if ( response.answer == 'success' ) {
        this.successCallback( 'Invoice type has been saved successfully' );
      } else this.global.defaultErrorCallback( 'error', false );
    });
  }

  exportSingleCSV ( ) {
    this.model.exportSingleCSV( this.id, ( response ) => {
      if ( response.answer == 'success' ) {

        let data = {
          type: 'success',
          title: 'Success',
          html: response.info.counter +' Invoice have been extracted into the CSV file: <a href="'+response.info.csv_link+'" download="'+response.info.filename+'" onClick="swal.close();">Download CSV</a>',
          showConfirmButton: false
        }
        this.global.successMessage( data );
        //this.extractedInvoices = response.info.csv_link;

      }
    });
  }

  changeApplyRebate(applyRebate, event: any){

    if( this.projectInfo.rebates_summ != '0.00' ) {
      this.model.saveApplyRebate( this.id, applyRebate, ( response ) => {
        let _answer = response.json( ).answer;
        if ( _answer == 'success' ) {
          this.successCallback( 'Apply Rebates parameter has been saved successfully' );
        } else this.global.defaultErrorCallback( _answer, false );
      });
    }
    else {
      this.global.defaultErrorCallback( 'There are no Rebates/Incentives for this project', false );
    }
  }

  changeCloneLineItems(cloneLineItems, event: any){

    this.model.saveCloneLineItems( this.id, cloneLineItems, ( response ) => {
      let _answer = response.json( ).answer;
      if ( _answer == 'success' ) {
        this.successCallback( 'Clone Line Item Counts parameter has been saved successfully' );
      } else this.global.defaultErrorCallback( _answer, false );
    });
  }

  ngOnInit ( ) {

    this.global.setProductRefPage( this.global.currRoute );

    this.global.getScrollPage( ).subscribe( isScroll => { this.triggerInitialScroll = isScroll; });

    this.route.params.subscribe( params => {
       this.id = +params['id'];
       this.invoiceMailInfo.project_id = this.id;
       this.loadData( false, true );
    });
  }

  getNotes ( ) {
    if ( this.order_id == 0 ) return;
    this.model.getNotes( 'order', this.order_id, ( notes ) => {
      this.notes = notes;
      this.projectInfo.notes = notes;
      this.hasNotes = notes.length != 0;
    });
  }

  addNote ( ) {

    let data = {
      message: "Are you sure the Note you are trying to add is correct? You will NOT be able to remove it from the Invoice after it was added",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    }

    this.global.confirmMessage( data, ( ) => {

      this.model.addNote( 'order', this.order_id, this.orderNote, ( response ) => {
        this.getNotes( );
        this.isRequiredNotesField = false;
        this.isNotesWasEdited = true;
      });

    });
  }

  minimizePopup ( ) { 
    this.popupMinimized = !this.popupMinimized; 
    this.fixingBodyOverflow( );
  }


  calculateHeights ( ) {

    // First graph
    if ( this.calculation.existing_kWhs_number && this.calculation.proposed_kWhs_number ) {
      let _existing1 = +( this.calculation.existing_kWhs_number );
      let _proposed1 = +( this.calculation.proposed_kWhs_number );
      this.graphHeights[0][0] = 250 * _existing1 / ( _existing1 + _proposed1 );
      this.graphHeights[0][1] = 250 * _proposed1 / ( _existing1 + _proposed1 );
    }
    // Second graph
    if ( this.calculation.lifetime_kWh_existing_number && this.calculation.lifetime_kWh_proposed_number ) {
      let _existing2 = +( this.calculation.lifetime_kWh_existing_number );
      let _proposed2 = +( this.calculation.lifetime_kWh_proposed_number );
      this.graphHeights[1][0] = 250 * _existing2 / ( _existing2 + _proposed2 );
      this.graphHeights[1][1] = 250 * _proposed2 / ( _existing2 + _proposed2 );
    }
  }


  showHistory ( ) { this.global.changeHPVisibility( true ); }

  generateInvoicePDF_handler ( ) {
    this.model.getInvoicePDF( this.calculation, this.id, this.projectInfo, ( url, responseData ) => {
      this.global.openLinkNewTab( url );

      this.invoiceMailInfo.mailFrom = responseData.mailFrom;
      this.invoiceMailInfo.mailTo = responseData.mailTo;
      this.invoiceMailInfo.cc = responseData.cc;
      this.invoiceMailInfo.subject = responseData.subject;
      this.invoiceMailInfo.message = responseData.message;
      this.invoiceMailInfo.is_mailed = responseData.is_mailed;
      this.invoiceMailInfo.is_generated = responseData.is_generated;
      this.is_saved_form = false;
      this.loadData( );
    });
  }

  viewInvoicePDF ( ) {
    this.global.openLinkNewTab( this.projectInfo.InvoicePDF );
  }

  generateInvoicePDF ( ) {

    if ( this.projectInfo.hasInactiveProducts ) {
      this.global.defaultErrorCallback( 'There are Inactive products in this Project, which need to be either replaced or removed', false );
    } else {
      this.generateInvoicePDF_handler( );
    }
  }

  changeDaysDue ( value ) {
    this.daysDueSelect = value;
    this.daysDue = '';
    if ( value != 'other' && value != '' ) this.daysDue = value;
  }

  checkLightsEqual ( ) {

    this.isHaveChangesInvoice = false;
    this.isHaveChangesBitcodes = false;

    if ( 
      this.depositAmountOld != this.depositAmountAdd ||
      this.paymentMethodOld != this.paymentMethod ||
      this.daysDueOld != this.daysDue
      ) {
      this.isHaveChangesInvoice = true;
    }

    this.proposedProductsOld.forEach( ( _old ) => {
      this.proposedProductsToSave.forEach( ( _new ) => {
        if ( _old.id == _new.id ) {
          if ( _old.bitCode != _new.bitCode ) {
            this.isHaveChangesInvoice = true;
            this.isHaveChangesBitcodes = true;
            return;
          }
        }
      });
    });

  }

  loadData ( scrollToNewZone?: boolean, firstLoad?: boolean ) {
    this.model.getZonesData( this.id, ( answer, data ) => {
      if ( answer == 'NotAllowed' ) {
        this.contentVisible = true;
        this.isAvailable = false;
        this.global.redirect( '/projects-list' );
      }
      else {
        this.contentVisible = true;
        if ( data.calculations ) this.calculation = data.calculations;
        this.projectInfo = data.projectInfo;
        this.options = data.options;
        this._videos = [];

        if ( data.projectInfo.videos.length && data.projectInfo.videos[0].before != '' ) {
          data.projectInfo.videos.forEach( _vd => {
            let _bf: any, _af: any;
            if ( _vd.before ) _bf = this.sanitizer.bypassSecurityTrustResourceUrl( _vd.before.toString( ).replace( 'watch?v=', 'embed/' ) );
            if ( _vd.after ) _af = this.sanitizer.bypassSecurityTrustResourceUrl( _vd.after.toString( ).replace( 'watch?v=', 'embed/' ) );
            this._videos.push({
              before:  _bf || '',
              after: _af || '',
              name: _vd.name
            });
          });
        }

        // if ( this.projectInfo['video_after'] ) this.projectInfo['video_after'] = this.sanitizer.bypassSecurityTrustResourceUrl( this.projectInfo.video_after.toString( ).replace( 'watch?v=', 'embed/' ) );
        this.choseForRemoveProducts = false;
        this.rebatesInfo = data.rebatesInfo;
        this.projectName = data.projectInfo.Name;
        this.projectZones = data.zones;
        this.has_order = data.projectInfo.has_order;
        this.was_saved = data.projectInfo.was_saved;
        this.proposedProductsOld = [];
        this.proposedProductsToSave = [];
        this.isHaveChangesInvoice = false;
        this.isHaveChangesBitcodes = false;
        let _product1;
        let _product2;
        this.calculation.product_list.proposed.forEach( ( product ) => {
          _product1 = {
            bitCode: product.bitCode,
            attachment: product.attachment,
            name: product.name,
            manufacturer: product.manufacturer,
            id: product.lightID,
            description: product.description,
            SKU: product.SKU
          };
          _product2 = {
            bitCode: product.bitCode,
            attachment: product.attachment,
            name: product.name,
            manufacturer: product.manufacturer,
            id: product.lightID,
            description: product.description,
            SKU: product.SKU
          };
          this.proposedProductsOld.push( _product1 );
          this.proposedProductsToSave.push( _product2 );
        });

        if ( data.projectInfo.paymentMethod ) this.paymentMethod = data.projectInfo.paymentMethod;
        if ( data.projectInfo.depositAmount !== undefined && data.projectInfo.depositAmount !== '' ) {
          this.depositAmount = data.projectInfo.depositAmount;
          this.depositAmountNumber = data.projectInfo.depositAmountNumber;
        } else {
          this.depositAmount = 0;
          this.depositAmountNumber = '0.00';
        }
        if ( data.projectInfo.invoice_id ) this.order_id = data.projectInfo.invoice_id;

        if ( data.purchaseInfo ) {
          this.purchaseInfo = data.purchaseInfo;
          this.selectParams.purchaseManufacturer.options = [ { text: '', value: '', title: '' } ];
          data.purchaseInfo.manufacturers.forEach( man => {
            this.selectParams.purchaseManufacturer.options.push( { text: man.name ,value: man.id, title: man.purchase_order } );
          });
        }

        this.depositAmountAdd = 0;
        this.depositOverride = '';

        this.depositAmountOld = this.depositAmountAdd;
        this.paymentMethodOld = this.paymentMethod;
        this.daysDue = this.projectInfo.daysDue;
        this.daysDueSelect = '';
        this.selectParams.daysDue.options.forEach( opt => { if ( opt.value == this.daysDue ) this.daysDueSelect = this.daysDue; });
        if ( this.daysDueSelect == '' && this.daysDue ) this.daysDueSelect = 'other';
        this.daysDueOld = this.projectInfo.daysDue;

        this.invoiceMailInfo.mailFrom = data.invoiceEmail.mailFrom;
        this.invoiceMailInfo.mailTo = data.invoiceEmail.mailTo;
        this.invoiceMailInfo.cc = data.invoiceEmail.cc;
        this.invoiceMailInfo.subject = data.invoiceEmail.subject;
        this.invoiceMailInfo.message = data.invoiceEmail.message;
        this.invoiceMailInfo.is_mailed = data.invoiceEmail.is_mailed;
        this.invoiceMailInfo.is_generated = data.invoiceEmail.is_generated;

        this.proposalEmail = data.proposalEmail;

        this.excludeLightingSchedule = data.colors.excludedSchedules;

        this.defaultSchedules = data.defaultSchedules || { dailyUse: '', weeklyUse: '', yearlyUse: '' };

        this.selectParams.purchaseManufacturer.isDisabled = !this.invoiceMailInfo.is_generated;

        if (!this.invoiceMailInfo.is_generated) {
          this.selectedPurchaseManufacturer = '';
        }

        this.permission = data.permission;
        if (data.permission == 'readOnly') {
          this.projectInfo.status = 'projectCompleted';
        }

        let visited_options_string = localStorage.getItem( 'visited_options' );
        if( visited_options_string ) {
          let visited_options = JSON.parse( visited_options_string );
          if( visited_options.hasOwnProperty( this.id.toString() ) ) {
            this.selectedOption = visited_options[ this.id.toString() ];
          }
        }

        if( ( data.projectInfo.active_option !== '' ) && ( data.projectInfo.initial_option === '' ) ) {

          this.selectedOption = data.projectInfo.active_option;
        }


        this.selectParams.productsOptions.options = [];
        if( parseFloat( this.calculation.A.productCost ) > 0 ) {
            this.selectParams.productsOptions.options.push( { text: 'Option A', value: 'A' } );
        }
        if( parseFloat( this.calculation.B.productCost ) > 0 ) {
            this.selectParams.productsOptions.options.push( { text: 'Option B', value: 'B' } );
        }
        if( parseFloat( this.calculation.C.productCost ) > 0 ) {
            this.selectParams.productsOptions.options.push( { text: 'Option C', value: 'C' } );
        }

        if( !this.projectInfo.show_in_proposal.includes('A') ) {
           this.showInProposal.A = false;
        }

        if( !this.projectInfo.show_in_proposal.includes('B') ) {
          this.showInProposal.B = false;
        }

        if( !this.projectInfo.show_in_proposal.includes('C') ) {
          this.showInProposal.C = false;
        }

        /*if( this.projectInfo.show_savings === 'A' ) {
          this.showSavings.A = true;
        }

        if( this.projectInfo.show_savings === 'B' ) {
          this.showSavings.B = true;
        }

        if( this.projectInfo.show_savings ==='C' ) {
          this.showSavings.C = true;
        }*/

        if( this.projectInfo.viaQuickbooks ) {
            this.viaQuickbooks = true;
        }

        if( this.projectInfo.apply_rebates ) {
          this.applyRebate = true;
        }

        if( this.projectInfo.clone_line_items ) {
          this.cloneLineItems = true;
        }

        // this.prepareColorsData( data.colors.colorMatches );
        this.calculateHeights( );
        this.prepareZonesData( data.zones );
        this.prepareColorsData( data.colors.excluded );
        this.prepareMoveProductsData( data.zones );
        this.checkLightsForCustomGroup( data.zones );
        this.getNotes( );
        if ( scrollToNewZone == true ) this.scrollToNewZone( );
        if ( firstLoad == true ) this.initialScroll( );
      }
    });
  }

  prepareZonesData ( zones ) {

    let emptyGroup = {
      countLights: 0,
      countExistingLights: 0,
      countProposedLights: 0,
      countDifference: 0,
      lights: {
        proposed: [],
        existing: [],
        emptyProposed: [],
        emptyExisting: []
      },
      groupID: 0
    };
    let i = 0;
    let _lightsCount = 0;
    let diff = 0;
    let groupsIndexes = [];
    let groups = [];
    let group = {
      countLights: 0,
      countExistingLights: 0,
      countProposedLights: 0,
      countDifference: 0,
      lights: {
        proposed: [],
        existing: [],
        emptyProposed: [],
        emptyExisting: []
      },
      groupID: 0
    };

    this.customZones = [];
    this.lightsCount = 0;

    zones.forEach( zone => {
      emptyGroup = {
        countLights: 0,
        countExistingLights: 0,
        countProposedLights: 0,
        countDifference: 0,
        lights: {
          proposed: [],
          existing: [],
          emptyProposed: [],
          emptyExisting: []
        },
        groupID: 0
      };
      groupsIndexes = [];
      groups = [];
      zone.groups = [];
      _lightsCount = 0;
      zone.lights.forEach( light => {
        this.projectHasProducts = true;
        ++_lightsCount;
        ++this.lightsCount;
        if ( !light.groupColor || light.groupColor == 0 ) {
          ++emptyGroup.countLights;
          if ( light.type == 'proposed' ) {
            ++emptyGroup.countProposedLights;
            emptyGroup.lights.proposed.push( light );
          } else {
            ++emptyGroup.countExistingLights;
            emptyGroup.lights.existing.push( light );
          }
          emptyGroup.countDifference = emptyGroup.countProposedLights - emptyGroup.countExistingLights;
          emptyGroup.lights.emptyProposed = [];
          emptyGroup.lights.emptyExisting = [];
          if ( emptyGroup.countDifference > 0 ) {
            for ( i = 0; i < emptyGroup.countDifference; ++i ) emptyGroup.lights.emptyExisting.push( 0 );
          } else {
            diff = -1 * emptyGroup.countDifference;
            for ( i = 0; i < -diff; ++i ) emptyGroup.lights.emptyProposed.push( 0 );
          }
        } else {
          if ( groupsIndexes.indexOf( light.groupColor ) == -1 ) {
            group = {
              countLights: 0,
              countExistingLights: 0,
              countProposedLights: 0,
              countDifference: 0,
              lights: {
                proposed: [],
                existing: [],
                emptyProposed: [],
                emptyExisting: []
              },
              groupID: light.groupColor
            }
            zone.groups.push( group );
            groupsIndexes.push( light.groupColor );
          } else {
            zone.groups.forEach( _group => { if ( _group.groupID == light.groupColor ) group = _group; });
          }
          ++group.countLights;
          if ( light.type == 'proposed' ) {
            ++group.countProposedLights;
            group.lights.proposed.push( light );
          } else {
            ++group.countExistingLights;
            group.lights.existing.push( light );
          }
          group.countDifference = group.countProposedLights - group.countExistingLights;
          group.lights.emptyProposed = [];
          group.lights.emptyExisting = [];
          if ( group.countDifference > 0 ) {
            for ( i = 0; i < group.countDifference; ++i ) group.lights.emptyExisting.push( 0 );
          } else {
            diff = -1 * group.countDifference;
            for ( i = 0; i < diff; ++i ) group.lights.emptyProposed.push( 0 );
          }
        }
        if ( zone.lights.length == _lightsCount && emptyGroup.countLights ) zone.groups.push( emptyGroup );
      });
      this.customZones.push( zone );
    });
  }

  prepareMoveProductsData ( zones ) {
    this.productsToMove = [];
    zones.forEach( zone => {
      zone.lights.forEach( light => {
        if ( light.type == 'proposed' && !light.mainProduct ) {
          this.productsToMove.push( light.id );
        }
      });
    });
  }

  checkLightsForCustomGroup ( zones ) {
    this.hasLightsForCustomGroup = false;
    zones.forEach( zone => {
      zone.lights.forEach( light => {
        if ( light.type == 'proposed' ) {
          this.hasLightsForCustomGroup = true;
        }
      });
    });
  }

  initialScroll ( ) {

    if ( !this.triggerInitialScroll ) return false;

    this.global.updateTriggeringScrollPage( true );

    setTimeout( ( ) => {
      if ( this.global.lastPositionOfProjectZonesData.projectID == this.id ) {
        if ( this.global.lastPositionOfProjectZonesData.offset == 0 ) {
          this.initialScrollingTriggered = true;
        } else {
          this.winRef.nativeWindow.scrollTo( 0, this.global.lastPositionOfProjectZonesData.offset );
          this.initialScrollingTriggered = true;
        }
      } else {
        this.global.setPZposition( this.id, 0 );
        this.initialScrollingTriggered = true;
      }
    }, 250 );
  }


  onScrollDocument ( event ) {

    if ( !this.initialScrollingTriggered ) return false;

    clearTimeout( this._scrollTopTimer );
    this._scrollTopTimer = setTimeout( ( ) => {
      if ( this.initialScrollingTriggered ) {
        this.global.setPZposition( this.id, this.winRef.nativeWindow.scrollY );
      } else {
        this.initialScrollingTriggered = true;
      }
    }, 350);
  }

  changeActiveTab ( activeTab ) { 
    if ( this.activeTab != activeTab ) {
      this.innerTabs.invoice = 'detail';
      this.activeTab = activeTab;
    }
    return false;
  }


  getExcludeID ( zoneID, type, entityID ) {

    let excludeID = [];

    this.projectZones.forEach( ( zone ) => {
      if ( zone.id == zoneID ) {
        zone.lights.forEach( ( light ) => {
          if ( light.option == this.selectedOption && excludeID.indexOf( light.entityID ) == -1 && light.entityID != entityID ) excludeID.push( light.entityID );
        });
      }
    });

    return excludeID;

  }

  onChangeCompareToCheckbox ( ) {
    if ( this.newLight.compare == true && this.filters.linkedQuantity ) this.newLight.quantity = this.filters.linkedQuantity;
  }

  addNewZone ( type ) { 
    this.newZone = new Zone( );
    this.newZone.projectID = this.id;

    this.newZonePopupVisible = true;
    //this.fixingBodyOverflow( );

    return false;
  }

  openCloneProjectPopup ( ) {

    let data = {
      message: "Are you sure you want to Clone this project?",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };

    this.global.confirmMessage( data, ( ) => {

      this.cloneProjectPopupVisible = true;
      this.cloneProjectName = '';
      this.fixingBodyOverflow( );

    });  

    return false;
  }

  closeCloneProjectPopup ( ) {
    this.cloneProjectPopupVisible = false;
    this.fixingBodyOverflow( );

  }

  changeOption( option ) {
    this.selectedOption = option;
    let visited_options_string = localStorage.getItem( 'visited_options' );
    let visited_options = {};
    if( visited_options_string ) {
      visited_options = JSON.parse( visited_options_string );
    }
    visited_options[this.id.toString()] = option;

    localStorage.setItem( "visited_options" , JSON.stringify( visited_options ) );
  }

  addNewLightHandler ( zoneID, type ) {

    this.newLight = new Light( );
    this.newLight.zoneID = zoneID;
    this.newLight.type = type;
    this.newLight.link = false;
    this.oldLightingSchedule = '';

    this.SKUSearch = '';
    this.descriptionSearch = '';
    if ( type == 'proposed' ) this.searchBySKU = true;
    if ( type == 'existing' ) this.searchBySKU = false;

    if ( this.defaultSchedules.dailyUse != '' )  this.newLight.dailyUse = this.defaultSchedules.dailyUse;
    if ( this.defaultSchedules.weeklyUse != '' ) this.newLight.weeklyUse = this.defaultSchedules.weeklyUse;
    if ( this.defaultSchedules.yearlyUse != '' ) this.newLight.yearlyUse = this.defaultSchedules.yearlyUse;
    
    if ( this.filters.link == true ) this.newLight.link = true;


    this.selectParams.overlayEntity.options = [
      { value: '', text: '' },
      { value: 'bulb', text: 'Lamp' },
      { value: 'fixture', text: 'Fixture' },
    ];
    if ( type=='proposed' ) {
      this.selectParams.overlayEntity.options.push({ value: 'accessory', text: 'Accessory' })
      this.selectParams.overlayEntity.options.push({ value: 'housing', text: 'Housing' })
    }

    this.newLightPopupVisible = true;
    this.fixingBodyOverflow( );
  }


  addNewLight ( zoneID, type ) {

    this.showAdditionalFields = false;
    this.isEdit = false;
    this.isProductFieldDisabled = true;
    this.isLinkedCurrentProduct = false;

    this.filters = {
      available_entity: '',
      need_proposed: false,
      compare:      false,
      link:         true,
      type:         type,
      entity:       '',
      productType:  '',
      baseType:     '',
      description:  '',
      zone:         zoneID,
      linkedDescription:  '',
      linkedQuantity:  0,
      excludeID:    this.getExcludeID ( zoneID, type, 0 )
    };

    this.global.showPreloader( );
    this.getProductsDataExcluding( ( products, _filters ) => {
      this.filters.linkedDescription = _filters.linkedDescription;
      this.filters.linkedQuantity = _filters.linkedQuantity || 0;
      this.filters.need_proposed = _filters.need_proposed;
      this.filters.link = false;
      if ( _filters.need_proposed == false ) this.global.hidePreloader( );
      if ( type == 'existing' && _filters.need_proposed == true ) {
        this.global.defaultErrorCallback( 'Please add comparable Proposed product or remove added Existing product "'+_filters.linkedDescription+'" before adding another Existing product', false );
        this.global.hidePreloader( );
        return false;
      }
      this.addNewLightHandler ( zoneID, type );
      if ( type == 'proposed' && _filters.need_proposed == true ) {
        this.searchBySKU = false;
        this.global.showPreloader( );
        if ( _filters.available_entity ) {
          this.filters.available_entity = _filters.available_entity;
          this.newLight.entity = _filters.available_entity;
          if ( _filters.linkedID ) {
            this.filters.linkedID = _filters.linkedID;
            this.filters.linkedDescription = _filters.linkedDescription;
            this.filters.linkedQuantity = _filters.linkedQuantity;
          }
          this.changeLightProperty ( 'entity', _filters.available_entity, true, true, ( ) => {
            this.global.showPreloader( );
            if ( _filters.productTypeThis ) {
              this.newLight.productType = _filters.productTypeThis;
              this.filters.productType = _filters.productTypeThis;
              this.prepareProductTypeList( );
              if ( _filters.linkedID ) {
                this.filters.linkedID = _filters.linkedID;
                this.filters.linkedDescription = _filters.linkedDescription;
                this.filters.linkedQuantity = _filters.linkedQuantity;
              }
              this.changeLightProperty ( 'productType', _filters.productTypeThis, true, true, ( ) => {
                if ( _filters.linkedQuantity ) this.newLight.quantity = _filters.linkedQuantity;
                if ( _filters.baseTypeThis ) {
                  this.changeLightProperty ( 'baseType', _filters.baseTypeThis, true, true, ( ) => {
                    this.newLight.baseType = _filters.baseTypeThis;
                    this.filters.baseType = _filters.baseTypeThis;
                    // this.prepareBaseTypeList( );
                    if ( _filters.linkedID ) {
                      this.filters.linkedID = _filters.linkedID;
                      this.filters.linkedDescription = _filters.linkedDescription;
                      this.filters.linkedQuantity = _filters.linkedQuantity;
                    }
                    this.model.getProductsDataExcluding( this.filters, 'baseType', ( products, _filters ) => {
                      this.productList = products;
                      this.productTypesList = _filters.productType;
                      this.baseTypesList = _filters.baseType;
                      this.SKUsList = _filters.description;
                      this.prepareProductTypeList( );
                      this.prepareBaseTypeList( );
                      this.prepareSKUsList( );
                      if ( _filters.linkedQuantity ) this.newLight.quantity = _filters.linkedQuantity;
                      if ( _filters.description.length ) this.filters.link = true;
                      this.global.hidePreloader( );
                    }, null, null, this.selectedOption );
                  });
                } else this.global.hidePreloader( );
              });
            } else this.global.hidePreloader( );
          });
        } else this.global.hidePreloader( );
      }
    }, true );

    return false;
  }


  prepareProductTypeList ( ) {

    this.selectParams.overlayProductType.options = [{ value: '', text: '' }];

    this.productTypesList.forEach( _pt => {
      this.selectParams.overlayProductType.options.push( { value: _pt, text: _pt } );
    });
  }

  prepareBaseTypeList ( ) {
    
    this.selectParams.overlayBaseType.options = [{ value: '', text: '' }];

    this.baseTypesList.forEach( _bt => {
      this.selectParams.overlayBaseType.options.push( { value: _bt, text: _bt } );
    });
  }

  prepareSKUsList ( ) {

    let _SKU = '';

    this.selectParams.overlayDescription.options = [{ value: '', text: '' }];
    if ( this.projectInfo.showProductCost ) {
      this.SKUsList.forEach( _ds => {
        _SKU = _ds.SKU || 'N/A';
        if (_ds.watts && +_ds.watts) {
          _SKU += ' ('+_ds.watts+'W)';
        }
        this.selectParams.overlayDescription.options.push( { value: _ds.id, text: '$'+_ds.sellPrice+' — '+_ds.manufacturer+' — '+_ds.description, title: _SKU } );
      });
    } else {
      this.SKUsList.forEach( _ds => {
        _SKU = _ds.SKU || 'N/A';
        if (_ds.watts && +_ds.watts) {
          _SKU += ' ('+_ds.watts+'W)';
        }
        this.selectParams.overlayDescription.options.push( { value: _ds.id, text: _ds.description+' — '+_ds.manufacturer, title: _SKU } );
      });
    }
  }

  changeLightProperty ( _type, _value, withoutPreloader?: boolean, is_linked?: boolean, cb? ) {
    

    let _withoutPreloader = false;
    if ( withoutPreloader ) _withoutPreloader = true;
    let _entity = this.newLight.entity;
    let _compare = this.newLight.compare;
    // this.filters.entity = _entity;
    this.filters.compare = _compare;

    if ( is_linked == true ) this.isLinkedCurrentProduct = true;

    if ( _type == 'entity' ) {
      this.filters.entity = _value;
      this.newLight.entity = _value;
      _entity = this.newLight.entity;
      this.filters.productType  = '';
      this.filters.baseType     = '';
      this.filters.description  = '';
      this.filters.search       = '';
      this.filters.linkedQuantity = 0;
      this.newLight.quantity = null;
      if ( _entity == 'accessory' ) {
        _compare = this.newLight.compare = this.filters.compare = false;
      }
    }

    if ( _type == 'search' ) {
      this.filters.search = _value;
      this.filters.searchDescription = '';
    }
    if ( _type == 'searchDescription' ) {
      this.filters.search = '';
      this.filters.searchDescription = _value;
      _type = 'search';
    }

    if ( _entity ) this.isProductFieldDisabled = false;
    else this.isProductFieldDisabled = true;

    if ( _type == 'baseType' ) {
      this.filters.description  = '';
      this.filters.baseType = _value;
    }

    if ( _type == 'productType' ) {
      this.filters.productType = _value;
      this.filters.description = '';
      if ( _value && _entity == 'fixture' ) {
        this.filters.baseType = 'N/A';
        _type = 'baseType';
      } else {
        this.filters.baseType     = '';
      } 

    }

    if ( _type != 'description' ) {
      this.filters.link = false;
      if ( is_linked == true ) this.filters.link = true;
      this.model.getProductsDataExcluding( this.filters, _type, ( products, _filters ) => {
        this.productList = products;
        this.productTypesList = _filters.productType;
        this.baseTypesList = _filters.baseType;
        this.SKUsList = _filters.description; 

        
        // else this.SKUsList = _filters.description;

        if ( _type != 'productType' && _type != 'baseType' ) this.prepareProductTypeList( );
        if ( _type != 'baseType' && _entity != 'fixture' ) this.prepareBaseTypeList( );
        this.prepareSKUsList( );
        
        if ( this.searchBySKU ) { 
          if ( _filters.description.length && _filters.description[0] != 'present' ) {
            this.filters.description = _filters.description[0].id;
            this.setNewLightEntityID(  _filters.description[0].id );
            this.changeLightProperty( 'description', _filters.description[0].id, true );
            return;
          } else {
            this.filters.entity = '';
            this.filters.productType = '';
            this.filters.baseType = '';
            this.newLight.entity = '';
            this.newLight.productType = '';
            this.newLight.baseType = '';
            this.productTypesList = [ ];
            this.baseTypesList = [ ];
            this.prepareProductTypeList( );
            this.prepareBaseTypeList( );
            this.filters.description = '';
            this.setNewLightEntityID(  '' );
            this.changeLightProperty( 'description', '', true );
            if (this.SKUSearch) {
              if ( _filters.description[0] == 'present' ) this.global.defaultErrorCallback( 'Product with SKU "'+this.SKUSearch+'" is already present in this zone and can not be added', false );
              else this.global.defaultErrorCallback( 'Product with SKU "'+this.SKUSearch+'" is not available', false );
            }
            if (this.descriptionSearch) {
              if ( _filters.description[0] == 'present' ) this.global.defaultErrorCallback( 'Product with description "'+this.descriptionSearch+'" is already present in this zone and can not be added', false );
              else this.global.defaultErrorCallback( 'Product with description "'+this.descriptionSearch+'" is not available', false );
            }
            
            return;
          }

        }
        
        if ( !( _type == 'entity' && _entity == 'accessory' ) ) {
          if ( _filters.linkedQuantity ) {
            this.filters.linkedQuantity = _filters.linkedQuantity;
            if ( _compare == true ) this.newLight.quantity = _filters.linkedQuantity;
            if ( this.isLinkedCurrentProduct == true && is_linked != true ) {
              this.isLinkedCurrentProduct = false;
              this.newLight.quantity = null;
            }
          }
        }
        if ( this.global.isFunction( cb ) ) cb( );
      }, undefined, _withoutPreloader, this.selectedOption );
    }


    if ( _type == 'description' && _value != '' ) {
      // this.filters.link = true;
      this.SKUSearch = '';
      this.descriptionSearch = '';
      this.model.getProductDataByID( _value, ( product ) => { 
        if ( product.specsPDF ) this.newLight['specsPDF'] = product.specsPDF;
        else this.newLight['specsPDF'] = '';
        this.currentLinkedProducts = product.linkedProducts;
        this.linkedProductsDescriptions = [];
        this.currentLinkedProducts.forEach( linkedProduct => { this.linkedProductsDescriptions.push( linkedProduct.description ); });
        if ( product.video ) this.newLight['video'] = this.sanitizer.bypassSecurityTrustResourceUrl( product.video.toString( ).replace( 'watch?v=', 'embed/' ) );
        else this.newLight['video'] = '';

        if ( this.searchBySKU ) {
          this.filters.entity = product.entity;
          this.filters.productType = product.productType;
          this.filters.baseType = product.baseType;

          this.newLight.entity = product.entity;
          this.newLight.productType = product.productType;
          this.newLight.baseType = product.baseType;
          this.productTypesList = [ product.productType ];
          this.baseTypesList = [ product.baseType ];
          this.prepareProductTypeList( );
          this.prepareBaseTypeList( );
          this.isProductFieldDisabled = false;
        }

        this.fillLightAdditionalInfo( product );
        if ( this.global.isFunction( cb ) ) cb( );
      }, { 'watts_in_integer': true });
    } else {
      if ( _type != 'compare' ) this.showAdditionalFields = false;
    }
  }


  editZone ( zoneID ) { 

    this.model.getZoneByID( zoneID, ( zone ) => { this.newZone = zone; });
    this.newZonePopupVisible = true;
    this.fixingBodyOverflow( );
    return false;
  }

  openSplitProductPopup ( zoneName, zoneID ) {

    // if ( this.checklinkedDescriptionInZone( zoneID, zoneName ) ) return;
    
    this.splitProductZoneID = zoneID;
    this.splitProductZoneName = zoneName;
    this.splitProductPopupVisible = true;
    
    let _zone_id = -1;

    this.projectZones.forEach( zone => {
      zone.lights.forEach( light => {
        if ( light.id == this.checkedProductToMove ) _zone_id = light.zoneID;
      });
    });

    this.splitLinkedToProposed = [];

    this.projectZones.forEach( zone => {
      if ( zone.id == _zone_id ) {
        zone.lights.forEach( light => {
          if ( light.mainProduct == this.checkedProductToMoveDescription && light.type == 'proposed' ) {
            this.splitLinkedToProposed.push( { id: light.id, description: light.description, quantity: light.quantity, maxQuantity: light.quantity } );
          }
        });
      }
    });

    let _linkedExisting = -1;

    this.projectZones.forEach( zone => {
      zone.lights.forEach( light => {
        if ( light.id == this.checkedProductToMove ) {
          this.splitProductQuantity = this.splitProductQuantityMax = light.quantity;
          if ( light.linked > 0 ) {
            _linkedExisting = light.linked;
            this.splitLightLinked = true;
          }
        }
      });
    });

    if ( this.splitLightLinked ) {
      this.projectZones.forEach( zone => {
        zone.lights.forEach( light => {
          if ( light.id == _linkedExisting ) {
            this.splitProductExistingQuantity = this.splitProductExistingQuantityMax = light.quantity;
          }
        });
      });
    }

    this.fixingBodyOverflow( );
  }

  cancelSplitProduct ( ) {
    this.splitProductQuantity = this.splitProductQuantityMax = 0;
    this.splitProductExistingQuantity = this.splitProductExistingQuantityMax = 0;
    this.splitLightLinked = false;
    this.splitProductPopupVisible = false;
    this.fixingBodyOverflow( );
  }
  
  openCloneZonePopup ( zoneID, zoneName ) {
    this.clonedZoneID = zoneID;
    this.clonedZoneName = zoneName + ' (copy)';
    this.cloneZonePopupVisible = true;
    this.fixingBodyOverflow( );
  }

  cancelCloneZone ( ) {
    this.cloneZonePopupVisible = false;
    this.fixingBodyOverflow( );
  }

  cloneZone ( ) { 

    this.model.cloneZone( this.clonedZoneID, this.clonedZoneName, ( zoneName, answer ) => { 
      if ( answer == 'exists' ) this.global.defaultErrorCallback( 'Zone with this name already exists', false );
      else if ( answer == 'empty' ) {
        this.global.defaultErrorCallback( 'This zone does not have any products and can not be cloned. Please select another zone.', false );
        this.cloneZonePopupVisible = false;
        this.fixingBodyOverflow( );
      } else {
        this.successCallback( 'Zone "' + zoneName + '" was created successfully', true );
        this.cloneZonePopupVisible = false;
        this.fixingBodyOverflow( );
      }
    });
    return false;
  }

  cloneProject ( ) { 
  
    this.global.updateTriggeringScrollPage( false );
    this.model.cloneProject( this.id, this.cloneProjectName, ( answer, id? ) => { 
      if ( answer == 'exists' ) {
        this.global.defaultErrorCallback( 'Project with this name already exists', false );
      } else {
        this.successCallback( 'Project "' + this.cloneProjectName + '" was created successfully', true );
        this.closeCloneProjectPopup( );
        this.global.redirect( '/project/edit/' + id );
      }
    });

    return false;
  }

  scrollToNewZone ( ) {

    setTimeout( ( ) => {
      let _i = 0;
      this.zonesElements.forEach( _zone => {
        ++_i;
        if ( _i == this.zonesElements.length ) _zone.nativeElement.scrollIntoView( true );
      });
    }, 3000 );


  };




  fillLightAdditionalInfo ( light ) {

      this.showAdditionalFields = true;
      this.additionalOverlayFields = {};
      this.additionalOverlayFields['linkedProducts'] = this.linkedProductsDescriptions.join( ', ' );
      this.additionalOverlayFields['description']    = light.description;
      this.additionalOverlayFields['SKU']            = light.SKU;
      this.additionalOverlayFields['attachment']     = light.attachment;
      this.additionalOverlayFields['entity']         = light.entity;

      if ( this.projectInfo.showProductCost ) this.additionalOverlayFields['sellPrice'] = '$'+light.sellPrice;

      if ( light.entity == 'fixture' || light.entity == 'bulb' ) {
        this.additionalOverlayFields['watts'] = light.watts;
        this.additionalOverlayFields['life'] = light.life;
      }

      if ( light.entity == 'fixture' ) {
        this.additionalOverlayFields['wattsPerLamp'] = light.wattsPerLamp;
        this.additionalOverlayFields['lampsPerProduct'] = light.lampsPerProduct;
      }

      if ( light.entity == 'housing' ) {
        this.additionalOverlayFields['lampsPerProduct'] = light.lampsPerProduct;
      }

      if ( this.projectInfo.showManufacturer == 1 ) {
        this.additionalOverlayFields['manufacturer'] = light.manufacturer_name;
      }

  }

  editLightHandler ( zoneID, lightID ) {

    this.model.getLightByID( lightID, ( light ) => { 
      this.newLight = light; 
      this.SKUSearch = '';
      this.descriptionSearch = '';
      if ( light.type == 'proposed' ) this.searchBySKU = true;
      if ( light.type == 'existing' ) this.searchBySKU = false;
      this.selectParams.overlayEntity.options = [
        { value: '', text: '' },
        { value: 'bulb', text: 'Lamp' },
        { value: 'fixture', text: 'Fixture' },
      ];
      if ( light.type=='proposed' ) {
        this.selectParams.overlayEntity.options.push({ value: 'accessory', text: 'Accessory' })
        this.selectParams.overlayEntity.options.push({ value: 'housing', text: 'Housing' })
      }
      this.model.getProductDataByID( light.entityID, ( product ) => {
        this.linkedProductsDescriptions = [];
        if ( product.linkedProducts ) product.linkedProducts.forEach( linkedProduct => { this.linkedProductsDescriptions.push( linkedProduct.description ); });
        this._newLightVideo = '';
        if ( this.newLight.video ) this._newLightVideo = this.sanitizer.bypassSecurityTrustResourceUrl( this.newLight.video.toString( ).replace( 'watch?v=', 'embed/' ) );

        this.oldLightingSchedule = light.scheduleType;
        // this.newLight.scheduleType = '';
        // this.newLight.Notes = '';

        this.fillLightAdditionalInfo ( light );

        this.filters = {
          need_proposed: false,
          compare:      this.newLight.compare,
          link:         false,
          type:         this.newLight.type,
          entity:       this.newLight.entity,
          productType:  this.newLight.productType,
          baseType:     this.newLight.baseType,
          description:  this.newLight.entityID,
          zone:         zoneID,
          linkedDescription:  '',
          linkedQuantity:  0,
          excludeID:    this.getExcludeID ( zoneID, this.newLight.type, this.newLight.entityID )
        };

        if ( this.newLight.type == 'proposed' ) {
          // this.filters.link = this.newLight.link;
          if ( light.linked > 0 ) this.filters.link = true;
        }

        this.model.getProductsDataExcluding( this.filters, this.newLight.type, ( products, _filters ) => {
          this.productList = products;
          this.productTypesList = _filters.productType;
          this.baseTypesList = _filters.baseType;
          this.SKUsList = _filters.description;
          this.prepareProductTypeList( );
          this.prepareBaseTypeList( );
          this.prepareSKUsList( );
          this.filters.linkedDescription = _filters.linkedDescription;
          this.filters.linkedQuantity = _filters.linkedQuantity || 0;
        }, 'projectZones', true, this.selectedOption ? this.selectedOption : 'A' );
      });
    });
    this.newLightPopupVisible = true;
    this.fixingBodyOverflow( );
  }

  editLight ( zoneID, light ) {

    this.isEdit = true;
    this.isProductFieldDisabled = false;
    this.editLightHasMainProduct = false;
    this.oldLightingSchedule = '';
    if ( light.type == 'proposed' && light.mainProduct ) this.editLightHasMainProduct = true;

    this.filters = {
      need_proposed: false,
      compare:      false,
      link:         false,
      type:         light.type,
      entity:       '',
      productType:  '',
      baseType:     '',
      description:  '',
      zone:         zoneID,
      linkedDescription:  '',
      linkedQuantity:  0,
      excludeID:    this.getExcludeID ( zoneID, light.type, light.entityID )
    };

    this.getProductsDataExcluding( ( products, _filters ) => {
      this.editLightHandler ( zoneID, light.id );
    });

    return false;
  }

  setNewLightEntityID ( entityID ) {
    this.newLight.entityID = entityID;
  }

  getProductsDataExcluding ( cb, withoutPreloader?: boolean ) {
    
    let _withoutPreloader = false;
    if ( withoutPreloader ) _withoutPreloader = true;

    this.model.getProductsDataExcluding( this.filters, '', ( products, _filters ) => {
      this.productList = products;
      this.productTypesList = _filters.productType;
      this.baseTypesList = _filters.baseType;
      this.SKUsList = _filters.description;
      this.prepareProductTypeList( );
      this.prepareBaseTypeList( );
      this.prepareSKUsList( );
      cb( products, _filters );
    }, undefined, _withoutPreloader, this.selectedOption );

  }




  successCallback ( message, scrollToNewZone?, cb? ) {
    this.newZonePopupVisible = false;
    this.newLightPopupVisible = false;
    let data = {
      type: 'success',
      title: 'Success',
      html: message || '',
      showConfirmButton: false
    }
    this.loadData( scrollToNewZone );
    this.global.successMessage( data );
    setTimeout( ( ) => { 
      swal.close( );
      this.fixingBodyOverflow( );
      if ( cb ) cb( );
    }, 2500 );
  }


  deleteLight ( id, type, linkedDescription?, lightDescription?, groupColor?,  ) {

    let _answer;
    let data = {
      message: "Are you sure you want to remove this selection?",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };

    if ( linkedDescription && type == 'proposed' ) {
      this.global.defaultErrorCallback( 'Please remove existing product "'+linkedDescription+'" before removing linked proposed product "'+lightDescription+'"', false );
      return;
    }

    if ( groupColor !== 0 && type == 'proposed' ) data.message = "Are you REALLY sure you want to remove this linked product? Note: It is not recommended";
     // data.message = "Are you REALLY sure you want to remove this linked product and break the group? Note: It is not recommended";


    this.global.confirmMessage( data, ( ) => {
      this.model.deleteLight( id, ( response ) => {
          _answer = response.json( ).answer;
          if ( _answer == 'success' ) this.successCallback( 'Selection has been removed successfully' );
          else if ( _answer == '' ) this.global.defaultErrorCallback( 'Please delete existing selection and this will remove proposed selection', false );
          else this.global.defaultErrorCallback( _answer, false );
          this.loadData( );
      });
    });

  }


  saveNewLightHandler ( ) {

    let _answer;

    this.newLight.withLinked = this.withLinked;

    if ( this.newLight.id !== undefined ) {
      this.model.editLight( this.newLight, ( response ) => {
        _answer = response.json( ).answer;
        if ( _answer == 'success' ) this.successCallback( 'Selection has been changed successfully!' );
        else if ( _answer == 'exists' ) this.global.defaultErrorCallback( 'Selection already exists in this zone', false );
        else this.global.defaultErrorCallback( _answer, false );
      });
    } else {
      this.newLight.option = this.selectedOption;
      this.model.addLight( this.newLight, ( response ) => {
        _answer = response.json( ).answer;
        if ( _answer == 'success' ) this.successCallback( 'New selection has been added successfully!' );
        else if ( _answer == 'exists' ) this.global.defaultErrorCallback( 'Selection already exists in this zone', false );
        else this.global.defaultErrorCallback( _answer, false );
      });
    }

  }
  
  getParentProductTypesOfExistingScheduleType ( ) {

    let parentProductTypes = '';

    this.projectZones.forEach( zone => {
      zone.lights.forEach( light => {
        if ( light.scheduleType == this.newLight.scheduleType && ( !light.groupColor || light.groupPosition == 'main' ) ) {
          if ( parentProductTypes == '' ) parentProductTypes = light.productType;
          else if ( parentProductTypes.indexOf( light.productType ) == -1 ) parentProductTypes += '", "' + light.productType;
        }
      });
    });

    return parentProductTypes;
  }

  saveNewLight_check ( ) {
    let isScheduleTypeChanged = false;
    let isScheduleTypeExist = false;
    let _parentProductType = '';
    let data = {
      message: "This Lighting Schedule Type already exists",
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };

    isScheduleTypeChanged = this.newLight.scheduleType && this.newLight.scheduleType != this.oldLightingSchedule;
    isScheduleTypeExist = this.excludeLightingSchedule.indexOf( this.newLight.scheduleType ) > -1;
    
    if ( isScheduleTypeChanged && isScheduleTypeExist ) {
      _parentProductType = this.getParentProductTypesOfExistingScheduleType( );
      data.message = 'This Lighting Type Schedule is already used by the group containing the following product types "' + _parentProductType + '". Do you want to re-use it for this group? Note: If you are adding the same group, leave Lighting Type Schedule field blank'
      // this.global.defaultErrorCallback( 'This Lighting Schedule Type already exists for "' + _parentProductType + '". If you are trying to add the same group, leave Lighting Schedule Type field blank', false );

      this.global.confirmMessage( data, ( ) => { this.saveNewLightHandler( ); });
    } else {
      this.saveNewLightHandler( );
    }
  }
  
  saveNewLight ( ) {
    this.newLight.link = this.filters.link;
    this.saveNewLight_check( );
  }

  saveNewZone ( ) {
    let _answer;
    if ( this.newZone.id !== undefined ) {
      this.model.editZone( this.newZone, ( response ) => {
        _answer = response.json( ).answer;
        if ( _answer == 'success' ) this.successCallback( 'Zone has been updated successfully!' );
        else if ( _answer == 'exists' ) this.global.defaultErrorCallback( 'Zone with this name already exists', false );
        else this.global.defaultErrorCallback( _answer, false );
      });
    } else {
      this.newZone.projectID = this.id;
      this.model.addZone( this.newZone, this.selectedOption, ( response ) => {
        _answer = response.json( ).answer;
        if ( _answer == 'success' ) this.successCallback( 'New zone has been added successfully!' );
        else if ( _answer == 'exists' ) this.global.defaultErrorCallback( 'Zone with this name already exists', false );
        else this.global.defaultErrorCallback( _answer, false );
      });
    }
  }

  saveInvoiceForm ( ) {


    if ( !this.was_saved && this.depositOverride != 0 && this.loginService.userInfo.role == 'admin' ) {
      if (this.depositOverride && +this.depositOverride < +this.projectInfo.calculatedDepositAmount ) {
        this.global.defaultErrorCallback( 'Deposit override can not be less than minimum ($' + this.projectInfo.calculatedDepositAmountNumber + ')', false );
        return;
      }
    }

    if (this.loginService.userInfo.role == 'admin' && +this.depositOverride > this.projectInfo.maxDepAmount && this.projectInfo.maxDepAmount > 0 ) {
      this.global.defaultErrorCallback( 'Deposit override can not be more than Balance due ($' + this.projectInfo.maxDepAmountNumber + ')', false );
      return;
    }

    if ( !this.isHaveChangesBitcodes && this.depositAmountAdd ) {
      if ( !this.was_saved && this.depositAmountAdd != 0 ) {
        if ( this.depositAmountAdd < +this.projectInfo.calculatedDepositAmount ) {
          this.global.defaultErrorCallback( 'Deposit amount can not be less than minimum ($' + this.projectInfo.calculatedDepositAmountNumber + ')', false );
          return;
        }
      }

      if ( this.projectInfo.maxDepAmount == 0 ) {
        this.global.defaultErrorCallback( 'Invoice has been paid in full. Adding deposit is not allowed', false );
        return;
      }

      if ( this.depositAmountAdd > this.projectInfo.maxDepAmount ) {
        this.global.defaultErrorCallback( 'Deposit amount can not be more than Balance due ($' + this.projectInfo.maxDepAmountNumber + ')', false );
        return;
      }
    }


    let _answer;
    let _data = {
      deposit_overwrite: this.depositOverride,
      paymentMethod: this.paymentMethod,
      depositAmount: this.depositAmountAdd,
      bitcodes: this.proposedProductsToSave,
      daysDue: this.daysDue
    };


    this.model.saveProjectOrder( this.id, _data, ( response ) => {
      _answer = response.answer;
      if ( _answer == 'success' ) {
        this.depositAmountAdd = 0;
        this.depositOverride = '';
        this.successCallback( 'Project information has been saved successfully' );
        this.has_order = true;
        this.was_saved = true;
        this.is_saved_form = true;
        this.loadData( );
        this.isNotesWasEdited = false;
      } else this.global.defaultErrorCallback( _answer, false );
    });
  }


  getProjectPurchaseInfoData ( ) {

    let __date;
    let _ctrl: boolean = false;

    // this.purchaseInfo.manufacturers.forEach( man => {
    //   if ( man.id == this.selectedPurchaseManufacturer ) _ctrl = true;
    // });
    // if ( !_ctrl ) this.selectedPurchaseManufacturer = '';

    this.model.getProjectPurchaseInfoData( this.selectedPurchaseManufacturer, this.id, ( response ) => {
      this.purchaseInfo['data'] = response.data;


      this.purchaseInfo.data.products.forEach( prod => {
        this.purchaseOrderRates.push( { id: prod.id, rate: prod.rate, selected: prod.selected, rate_discount: prod.rate_discount, rate_new: prod.rate_new } );
      });

      this.dumpedPurchaseOrderRates = [...this.purchaseOrderRates];

      if ( response.data.id != 0 ) this.purchaseOrderNumber = 2999 + response.data.id;
      if ( !response.data.mailFrom ) response.data.mailFrom = this.defaultEmail;
      if ( !response.data.cc ) response.data.cc = '';
        this.prepopulatedPurchaseShipping      = this.projectInfo.Company + '<br />' + this.projectInfo.Contact + '<br />' + this.projectInfo.ShippingStreet + '<br />' + this.projectInfo.ShippingCity + ', ' + this.projectInfo.ShippingState + ' ' +this.projectInfo.ShippingZipCode;
      if ( !this.purchaseInfo.data.is_generated ) {
        // this.prepopulatedPurchaseShipping      = this.purchaseInfo.data.shippingAddress.replace(/\n/g, "<br/>").replace(/\u21B5/g, "<br/>").replace(/↵/g, "<br/>");
        this.purchaseInfo.data.shippingAddress = '';
      } else {
        // this.prepopulatedPurchaseShipping      = this.purchaseInfo.data.shippingAddress.replace(/\n/g, "<br/>").replace(/\u21B5/g, "<br/>").replace(/↵/g, "<br/>");
        this.purchaseInfo.data.shippingAddress = this.purchaseInfo.data.shippingAddress.replace(/\n/g, "<br/>").replace(/\u21B5/g, "<br/>").replace(/↵/g, "<br/>");
      }
      this.currentShippingAddress = this.purchaseInfo.data.shippingAddress;
      this.purchaseInfo.data.address         = this.purchaseInfo.data.address.replace(/\n/g, "<br/>").replace(/\u21B5/g, "<br/>").replace(/↵/g, "<br/>");
      // this.purchaseInfo.data.shippingAddress = this.purchaseInfo.data.shippingAddress.replace(/\n/g, "<br/>").replace(/\u21B5/g, "<br/>").replace(/↵/g, "<br/>");
      __date = response.data.orderDate.toString( ).split( '-' );
      this.purchaseDate = new Date( __date[0], +__date[1]-1, __date[2] );
      this.purchaseDate_formatted = ( this.purchaseDate.getMonth( ) + 1 ) + '/' + this.purchaseDate.getDate( ) + '/' + this.purchaseDate.getFullYear( );
      this.purchaseInfo.data.products.forEach((product) => {
        // this.changeProductRate(product);
        this.changeProductDiscountRate(product);
      });
    });
  }

  changePurchaseManufacturer ( value ) {
    // let value = target.value;
    this.selectedPurchaseManufacturer = value;
    this.freshPurchaseOrderData ( );
    if ( value ) {
      this.getProjectPurchaseInfoData ( );
    } else {
      delete this.purchaseInfo['data'];
    }

  }



  freshPurchaseOrderData ( ) {
    this.purchaseOrderNumber = 0;
    this.defaultEmail = 'lumigenie@gmail.com';
    this.purchaseDate = new Date( );
  }

  submitPurchaseOrder ( ) {


    if ( this.controllPurchaseStatus == 'generatePDF' ) this.generateManufacturerPurchasePDF( );
    if ( this.controllPurchaseStatus == 'sendEmail' ) this.sendManufacturerEmail( );

    return false;
  }




  preparePurchaseData_addresses ( sendingData ) {

    if ( $( '#textareaPurchaseMailingAddress' ).length == 1 ) this.purchaseInfo.data.address = $( '#textareaPurchaseMailingAddress' ).html( );
    if ( $( '#textareaPurchaseShippingAddress' ).length == 1 ) this.purchaseInfo.data.shippingAddress = $( '#textareaPurchaseShippingAddress' ).html( );
    if ( $( '#textareaSpecialInstructions' ).length == 1 ) this.purchaseInfo.data.specialInstructions = $( '#textareaSpecialInstructions' ).html( );
    sendingData.address = this.purchaseInfo.data.address;
    sendingData.shippingAddress = this.purchaseInfo.data.shippingAddress;
    sendingData.specialInstructions = this.purchaseInfo.data.specialInstructions;
    return sendingData;
  }


  /*
    So, we have 3 conditions.
    1. We fill Address fields - generating PDF
    2. We fill Email fields - prepare data for sending emails
    3. We already generate and send it all 
  */
  preparePurchaseData ( ) {

    let sendingData = {
      id:               this.purchaseInfo.data.id,
      manufacturer_id:  this.purchaseInfo.data.manufacturer_id,
      project_id:       this.purchaseInfo.data.project_id,
      products:         this.purchaseInfo.data.products,
      totalAmount:      this.purchaseInfo.data.total_amount,
      manufacturer:     this.purchaseInfo.data.manufacturer,
      orderNumber:      this.purchaseOrderNumber,
      address:          '',
      shippingAddress:  '',
      mailFrom:         '',
      mailTo:           '',
      cc:               '',
      subject:          '',
      message:          '',
      specialInstructions: '',
      orderDate:        this.purchaseDate.getFullYear( ) + '-' + ( this.purchaseDate.getMonth( ) + 1 ) + '-' + this.purchaseDate.getDate( )
    };

    sendingData = this.preparePurchaseData_addresses( sendingData );

    if ( !this.purchaseInfo.data.is_mailed || this.purchaseInfo.data.is_generated ) {

      if ( !this.purchaseInfo.data.is_generated ) this.purchaseInfo.data.message = $( '#textareaEmailMessage' ).html( );

      sendingData.mailFrom = this.purchaseInfo.data.mailFrom;
      sendingData.mailTo   = this.purchaseInfo.data.mailTo;
      sendingData.cc       = this.purchaseInfo.data.cc;
      sendingData.subject  = this.purchaseInfo.data.subject;
      sendingData.message  = document.getElementById('textareaEmailMessage') ? document.getElementById('textareaEmailMessage').innerHTML : '';
    }

    return sendingData;
  }


  validateGeneratingPurchase ( ) {

    let _address;
    let _shippingAddress;
    let _specialInstructions;
    _address = $.trim( $( '#textareaPurchaseMailingAddress' ).text( ) );
    _shippingAddress = $.trim( $( '#textareaPurchaseShippingAddress' ).text( ) );
    _specialInstructions = $.trim( $( '#textareaSpecialInstructions' ).text( ) );

    if ( _address == "" ) {
      this.global.defaultErrorCallback( 'Field "Manufacturer address" cannot be empty!', false );
      return false;
    }

    if ( _shippingAddress == "" ) {
      this.global.defaultErrorCallback( 'Field "Shipping address" cannot be empty!', false );
      return false;
    }

    if ( _specialInstructions == "" ) {
      this.global.defaultErrorCallback( 'Field "Special Instructions" cannot be empty!', false );
      return false;
    }

    return true;
  }

  validateMailingPurchase ( ) {

    let _message;
    _message = $.trim( $( '#textareaEmailMessage' ).text( ) );

    if ( _message == "" ) {
      this.global.defaultErrorCallback( 'Field "Message to manufacturer" cannot be empty!', false );
      return false;
    }

    return true;
  }


  generateManufacturerPurchasePDF ( ) {

    // if ( !this.purchaseInfo.data.is_generated )
    if ( !this.validateGeneratingPurchase ( ) ) return;

    let sendingData = this.preparePurchaseData( );

    let data = {
      message: "Before generating Purchase Order PDF you MUST click on Save button, if it is clickable.",
      confirmButtonText: "OK",
      cancelButtonText: "Cancel"
    };

    this.global.confirmMessage( data, ( ) => {
      this.model.generateManufacturerPurchasePDF( sendingData, ( response ) => {
        this.successCallback( 'Purchase Order was generated successfully', false, ( ) => { this.getProjectPurchaseInfoData( ); } );
      });
    });

  }

  sendManufacturerEmail ( ) {
    
    if ( !this.validateMailingPurchase ( ) ) return;

    let sendingData = this.preparePurchaseData( );

    if ( this.purchaseInfo.data.is_mailed ) {

      // message: "You will NOT be able to re-send this Purchase Order. Please make sure ALL information on this form is 100% correct"
      // message: "Purchase Order for this Project was already sent. Do you want to send it again?"
      let data = {
        message: "This Purchase Order was already emailed. Do you want to email it again?"
      }

      this.global.confirmMessage( data, ( ) => {
        this.model.sendManufacturerEmail( sendingData, ( response ) => {
          this.successCallback( 'Purchase Order was emailed successfully!', false, ( ) => { this.getProjectPurchaseInfoData( ); } );
        });
      });
    } else {
      

      let data = { message: 'Is information in "To", "Subject" and "Your message to client" fields correct and up to date?<br />Purchase Order PDF MUST be re-generated before emailing. Did you do that?' };

      this.global.confirmMessage( data, ( ) => {
        this.model.sendManufacturerEmail( sendingData, ( response ) => {
          this.successCallback( 'Purchase Order was emailed successfully!', false, ( ) => { this.getProjectPurchaseInfoData( ); } );
        });
      });
    }


  }


  controllPurchase ( ctrl: string ) {
    this.controllPurchaseStatus = ctrl;
  }

  cancelNewLight ( ) { 
    this.newLightPopupVisible = false;
    this.fixingBodyOverflow( );
  }
  cancelNewZone ( ) { 
    this.newZonePopupVisible = false;
    this.fixingBodyOverflow( );
  }


  changeInvoiceInnerTab ( tabname: string ) { this.innerTabs.invoice = tabname; }


  sendInvoiceMail ( ) {

    let _message;
    _message = $.trim( $( '#textareaInvoiceEmailMessage' ).text( ) );

    if ( _message == "" ) {
      this.global.defaultErrorCallback( 'Field "Message to client" cannot be empty!', false );
      return false;
    }

    this.invoiceMailInfo.message = $( '#textareaInvoiceEmailMessage' ).html( );



    // let data = { message: 'Is information in "To", "Subject" and "Your message to client" fields correct and up to date?' };
    let data = { 
      message: 'Did you click on "View Invoice" button to make sure you are emailing the latest version of Invoice?',
      confirmButtonText: "OK",
      cancelButtonText: "Cancel"
    };

    if (this.invoiceMailInfo.is_mailed) {
      data.message = 'Invoice for this Project was already emailed. Do you want to email it again?';
    }

    this.global.confirmMessage( data, ( ) => {
      this.model.sendDataEmail( this.invoiceMailInfo, ( response ) => {

        this.successCallback( 'Invoice was emailed successfully!' );
        this.invoiceMailInfo.mailFrom = response.data.mailFrom;
        this.invoiceMailInfo.mailTo = response.data.mailTo;
        this.invoiceMailInfo.cc = response.data.cc;
        this.invoiceMailInfo.subject = response.data.subject;
        this.invoiceMailInfo.message = response.data.message;
        this.invoiceMailInfo.is_mailed = response.data.is_mailed;
        this.invoiceMailInfo.is_generated = response.data.is_generated;

      });
    });

  }



  // Change colors
  changeProductTypeColor( eventData ) {

    let _sendData: object = {};

    _sendData['projectID'] = this.id;
    _sendData['productType'] = this.filters.productType;
    _sendData['colorID'] = eventData.colorID;

    this.model.changeProductTypeColor( _sendData, ( ) => { this.loadData( ); });

  }

  changeCombinationColor( eventData, light ) {

    light.groupColor = eventData.colorID;

    this.model.editLight( light, ( response ) => { 
      this.loadData( );
    });

  }


  prepareColorsData ( colorMatches ) {

    let _colorTitle = '';
    let _bindedTitle = '';

    this.bindedColors = [];
    colorMatches.forEach( colorData => {
      this._colorsList.forEach( _dataColor => {
        if ( _dataColor.colorID == colorData.colorID ) {
          _colorTitle = colorData.productTypes.join( ', ' );
          _bindedTitle = colorData.productTypes.join( ', ' );
          if ( colorData.scheduleType ) _colorTitle += ': Lighting Schedule Type - ' + colorData.scheduleType;
          else _colorTitle += ': Lighting Schedule Type - N/A' + colorData.scheduleType
          this.bindedColors.push( { clickable: colorData.clickable, color: _dataColor.color, bindedData: _colorTitle, bindedDataTitle: _bindedTitle, colorID: colorData.colorID } );
        }
      });
    });

    if ( this.calculation.product_list_by_zones.A ) {
      this.calculation.product_list_by_zones.A.forEach( _proposed => {
        this.bindedColors.forEach( _colorBinding => {
          if ( _colorBinding.bindedDataTitle == _proposed.productType ) _proposed['colorBinding'] = _colorBinding.color;
        });
      });
    }

  }

  removeCopiedFrom( ) {

    let data = { message: "Are you sure you want to remove 'copied from' text for current option?" };

    this.global.confirmMessage( data, ( ) => {
      this.model.removeCopiedFrom( this.id, this.selectedOption, ( ) => {
        this.successCallback( "'Copied from' text has been removed successfully" );
        this.loadData( );
      });
    });
  }

  resetColors ( ) {

    let data = { message: "Are you sure you want to remove color-coding of ALL products in this project?" };

    this.global.confirmMessage( data, ( ) => {
      this.model.resetColorsBindings( this.id, ( ) => {
        this.successCallback( 'Color-coding has been removed successfully' );
        this.loadData( );
      });
    });
  }


  // Wipe zone functionality
  wipeZone ( zoneID ) {

    let _index = this.global.wipedZones.indexOf( zoneID );
    ( _index > -1 ) ? this.global.removeWipedZone( zoneID ) : this.global.addWipedZone( zoneID );
    if ( _index > -1 ) this.loadData( );
  }



  fixingBodyOverflow ( ) {
    this.global.fixBodyOverflow( 
      ( 
        ( this.newLightPopupVisible == true && this.popupMinimized == false ) || 
        this.newZonePopupVisible == true || 
        this.cloneProjectPopupVisible == true || 
        this.cloneZonePopupVisible == true || 
        (this.splitProductPopupVisible == true && 
          this.popupMinimized == false ) 
        ) 
      );
  }


  moveProductToZone ( zoneName, zoneID ) {

    if ( this.checklinkedDescriptionInZone( zoneID, zoneName ) ) return;

    let data = { message: 'Are you sure you want to move selected product to zone "' + zoneName + '"?' };
    let LPL = [];
    let _zone_id = -1;
    let _linked = -1;

    this.projectZones.forEach( zone => {
      zone.lights.forEach( light => {
        if ( light.id == this.checkedProductToMove ) {
          _zone_id = light.zoneID;
          _linked = light.linked;
        }
      });
    });

    this.projectZones.forEach( zone => {
      if ( zone.id == _zone_id ) {
        zone.lights.forEach( light => {
          if ( light.mainProduct == this.checkedProductToMoveDescription && light.type == 'proposed' ) LPL.push( light.id );
        });
      }
    });

    if ( LPL.length || _linked > 0 ) {
      data = { message: 'Are you sure you want to move selected product and its linked product(s) to zone "' + zoneName + '"?' };
    }

    this.global.confirmMessage( data, ( ) => {

      this.model.moveLightToAnotherZone( zoneID, this.checkedProductToMove, LPL, ( answer ) => {
        this.successCallback( 'Products have been moved to zone "' + zoneName + '" successfully!' );
        this.splitProductZoneName = '';
        this.splitProductZoneID = 0;
        this.splitProductQuantity = 0;
        this.splitProductExistingQuantity = 0;
        this.checkedProductToMove = 0;
        this.checkedProductToMoveDescription = '';
        this.splitProductQuantityMax = 0;
        this.splitProductExistingQuantityMax = 0;
        this.splitLightLinked = false;
        this.hasProductsToMove = false;
        this.loadData( );
      });
    });

  }

  checklinkedDescriptionInZone ( zoneID, zoneName ) {

    let _exist: boolean = false;
    let _exist2: boolean = false;
    let _proposedLight, _linkedDescription = '';

    this.projectZones.forEach( zone => {
      zone.lights.forEach( light => {
        if ( light.id == this.checkedProductToMove ) _proposedLight = light;
      });
    });

    this.projectZones.forEach( zone => {
      zone.lights.forEach( light => {
        if ( _proposedLight ) {
          if ( light.id == _proposedLight.linked ) _linkedDescription = light.description;
        }
      });
    });

    this.projectZones.forEach( zone => {
      if ( zoneID == zone.id ) {
        zone.lights.forEach( light => {
          if ( light.description == this.checkedProductToMoveDescription ) _exist = true;
          if ( light.type == 'existing' && light.description == _linkedDescription && _linkedDescription != '' ) _exist2 = true;
        });
      }
    });

    if ( _exist ) this.global.defaultErrorCallback( 'Product "' + this.checkedProductToMoveDescription + '" is already present in zone "' + zoneName + '"', false );
    if ( _exist2 ) this.global.defaultErrorCallback( 'Product "' + _linkedDescription + '" is already present in zone "' + zoneName + '"', false );

    return ( _exist || _exist2 );
  }

  splitProductToZone ( $event ) {
    $event.preventDefault( );
    let _fromZone = '';
    this.projectZones.forEach( zone => {
      zone.lights.forEach( light => {
        if ( light.id == this.checkedProductToMove ) _fromZone = zone.name;
      });
    });
    let data = { message: 'Are you sure you want to move "' + this.checkedProductToMoveDescription + '" (Qty: ' + this.splitProductQuantity + ') from zone "' + _fromZone + '" into this zone "' + this.splitProductZoneName + '"?' };
    let _light;

    if ( this.splitLinkedToProposed.length ) data = { message: 'Are you sure you want to move "' + this.checkedProductToMoveDescription + '" (Qty: ' + this.splitProductQuantity + ') and its linked product(s) from zone "' + _fromZone + '" into this zone "' + this.splitProductZoneName + '"?' };

    this.global.confirmMessage( data, ( ) => {

      if ( this.splitLightLinked ) {
        this.model.splitLightToAnotherZone( this.splitProductZoneID, this.splitProductQuantity, this.splitProductExistingQuantity, this.checkedProductToMove, ( answer ) => {
          this.successCallback( 'Products have been splited to zone "' + this.splitProductZoneName + '" successfully!' );
          this.splitProductZoneName = '';
          this.splitProductZoneID = 0;
          this.splitProductQuantity = 0;
          this.splitProductExistingQuantity = 0;
          this.splitProductPopupVisible = false;
          this.splitLightLinked = false;
          this.splitLightIsLinkedTo = false;
          this.splitProductQuantityMax = 0;
          this.splitProductExistingQuantityMax = 0;
          this.checkedProductToMove = 0;
          this.checkedProductToMoveDescription = '';
          this.hasProductsToMove = false;
          this.fixingBodyOverflow( );
          this.loadData( );
        }, this.splitLinkedToProposed );
      } else {
        this.model.splitLightToAnotherZone( this.splitProductZoneID, this.splitProductQuantity, undefined, this.checkedProductToMove, ( answer ) => {
          this.successCallback( 'Products have been splited to zone "' + this.splitProductZoneName + '" successfully!' );
          this.splitProductZoneName = '';
          this.splitProductZoneID = 0;
          this.splitProductQuantity = 0;
          this.splitProductExistingQuantity = 0;
          this.splitProductPopupVisible = false;
          this.splitLightLinked = false;
          this.splitLightIsLinkedTo = false;
          this.splitProductQuantityMax = 0;
          this.splitProductExistingQuantityMax = 0;
          this.checkedProductToMove = 0;
          this.checkedProductToMoveDescription = '';
          this.hasProductsToMove = false;
          this.fixingBodyOverflow( );
          this.loadData( );
        }, this.splitLinkedToProposed );
      }
    });


  }

  changeProductMoveRadioButton ( light ) {
    this.hasProductsToMove = true;
    this.checkedProductToMove = light.id;
    this.checkedProductToMoveDescription = light.description;
    this.splitLightIsLinkedTo = false;
    if ( light.mainProduct ) this.splitLightIsLinkedTo = true;
  }

  onInputSplit ( _field, maxValue, event ) {
    if ( _field < 1 ) {
      _field = 1;
      event.target.value = 1;
    }
    if ( _field > maxValue ) {
      _field = maxValue;
      event.target.value = maxValue;
    }
  }


  deleteZone ( zoneID, zoneName ) {

    let _answer;
    let data = {
      message: 'Are you sure you want to delete zone "'+zoneName+'" from this and ALL other created Options?',
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };


    this.global.confirmMessage( data, ( ) => {
      this.model.deleteZone( zoneID, ( response ) => {
          _answer = response.json( ).answer;
          if ( _answer == 'success' ) this.successCallback( 'Zone has been removed successfully' );
          else this.global.defaultErrorCallback( _answer, false );
          this.loadData( );
      });
    });

  }

  deleteColor ( light, lightID ) {

    let _answer;

    light.groupColor = -lightID;

    this.model.editLight( light, ( response ) => {
        _answer = response.json( ).answer;
        // if ( _answer == 'success' ) this.successCallback( 'Zone has been removed successfully' );
        // else this.global.defaultErrorCallback( _answer, false );
        this.loadData( );
    });
  }


  changeControlGroup ( lightID, zoneID ) {
    this.customGroup.hasProposed = false;
    if ( this.customGroup.group.indexOf( lightID ) == -1 ) this.customGroup.group.push( lightID );
    else this.customGroup.group.splice( this.customGroup.group.indexOf( lightID ), 1 );
    this.projectZones.forEach( zone => {
      zone.lights.forEach( _light => {
        if ( this.customGroup.group.indexOf( _light.id ) > -1 && _light.type == 'proposed' ) this.customGroup.hasProposed = true;
      });
    });
    this.customGroup.currentZone = this.customGroup.group.length ? zoneID : 0;
  }

  changeProductsToRemove(lightID) {
    if ( this.productsToRemove.indexOf( lightID ) == -1 ) this.productsToRemove.push( lightID );
    else this.productsToRemove.splice( this.productsToRemove.indexOf( lightID ), 1 );
  }

  createCustomLightsGroup ( ) {
    let _answer;
    this.model.addCustomLightsGroup( this.customGroup.group, ( response ) => {
        _answer = response.json( ).answer;
        if ( _answer == 'success' ) this.successCallback( 'New custom group has been created successfully!' );
        else this.global.defaultErrorCallback( _answer, false );
        this.loadData( );
        this.customGroup = {
          currentZone: 0,
          group: [],
          hasProposed: false
        };
    });

  }



  onInputScheduleType ( event ) {
    if ( this.newLight.scheduleType ) {
      // event.target.value = event.target.value.charAt( 0 ).toUpperCase( ) + event.target.value.slice( 1 );
      // this.newLight.scheduleType = this.newLight.scheduleType.charAt( 0 ).toUpperCase( ) + this.newLight.scheduleType.slice( 1 );
      // event.target.value = event.target.value.replace( /\b\w/g, l => l.toUpperCase( ) );
      // this.newLight.scheduleType = this.newLight.scheduleType.replace( /\b\w/g, l => l.toUpperCase( ) );
    
      event.target.value = event.target.value.toUpperCase( );
      this.newLight.scheduleType = this.newLight.scheduleType.toUpperCase( );
    }
  }


  searchSKU ( $event ) {

    this.SKUSearch = $event.value;
    this.changeLightProperty( 'search', this.SKUSearch );

  }

  searchDescription ( $event ) {

    this.descriptionSearch = $event.value;
    this.changeLightProperty( 'searchDescription', this.descriptionSearch );

  }


  changePropopulatingPurchaseShipping ( ) {
    if ( this.prepopulatePurchaseShipping ) {
      this.purchaseInfo.data.shippingAddress = this.prepopulatedPurchaseShipping;
    } else {
      this.purchaseInfo.data.shippingAddress = this.currentShippingAddress;
    }
  }

  changeProductDiscountRate ( product ) {
    product.rate_new = ( product.rate * ( 1 - product.rate_discount / 100 ) ).toFixed(2);
    product.total_amount = +product.rate_new * (+product.light_quantity);
    this.purchaseInfo.data.total_amount = 0;
    this.purchaseInfo.data.products.forEach( prod => {
      if (prod.selected) {
        this.purchaseInfo.data.total_amount += +prod.total_amount;
      }
    });

    this.purchaseInfo.data.total_amount = parseFloat(this.purchaseInfo.data.total_amount).toFixed( 2 ).toString( );

    this.purchaseInfo.data.products.forEach( prod => {
      prod.total_amount = parseFloat(prod.total_amount).toFixed( 2 ).toString( );
    });

    this.purchaseOrderRates = [];

    this.saveRateButtonDisabled = true;

    this.purchaseInfo.data.products.forEach( prod => {
      this.purchaseOrderRates.push( { id: prod.id, rate: prod.rate, selected: prod.selected, rate_discount: prod.rate_discount, rate_new: prod.rate_new } );
      this.dumpedPurchaseOrderRates.forEach( dmp => {
        if ( dmp.id == prod.id && (+dmp.rate_new != +prod.rate_new || dmp.selected != prod.selected) ) this.saveRateButtonDisabled = false;
      });
    });
    this.purchaseInfo.data.products.forEach( prod => {
      if ( !prod.rate_new || +prod.rate_new <= 0 ) this.saveRateButtonDisabled = true;
    });
    product.rate_new = parseFloat(product.rate_new).toFixed( 2 ).toString( );

  }
  changeProductRate ( product ) {
    product.total_amount = +product.rate * ( 100 - product.rate_discount ) / 100 * (+product.light_quantity);
    product.rate_new = ( product.rate * ( 1 - product.rate_discount / 100 ) ).toFixed(2);
    this.purchaseInfo.data.total_amount = 0;
    this.purchaseInfo.data.products.forEach( prod => {
      if (prod.selected) {
        this.purchaseInfo.data.total_amount += +prod.total_amount;
      }
    });

    this.purchaseInfo.data.total_amount = parseFloat(this.purchaseInfo.data.total_amount).toFixed( 2 ).toString( );

    this.purchaseInfo.data.products.forEach( prod => {
      prod.total_amount = parseFloat(prod.total_amount).toFixed( 2 ).toString( );
    });

    this.purchaseOrderRates = [];

    this.saveRateButtonDisabled = true;

    this.purchaseInfo.data.products.forEach( prod => {
      this.purchaseOrderRates.push( { id: prod.id, rate: prod.rate, selected: prod.selected, rate_discount: prod.rate_discount, rate_new: prod.rate_new } );
      this.dumpedPurchaseOrderRates.forEach( dmp => {
        if ( dmp.id == prod.id && (+dmp.rate != +prod.rate || dmp.selected != prod.selected) ) this.saveRateButtonDisabled = false;
      });
    });
    this.purchaseInfo.data.products.forEach( prod => {
      if ( !prod.rate || +prod.rate <= 0 ) this.saveRateButtonDisabled = true;
    });

  }

  saveRates ( ) {

      let data = {
          message: "If Rate was updated, it will become new Buy Price for product (s). Do you want to proceed? Note: You MUST regenerate/re-email Invoice if Rate was updated",
          confirmButtonText: "OK",
          cancelButtonText: "Cancel"
      };

      this.global.confirmMessage( data, ( ) => {

          let _answer;

          this.model.saveRates( this.id, this.selectedPurchaseManufacturer, this.purchaseOrderRates, ( response ) => {
              _answer = response.answer;
              this.saveRateButtonDisabled = true;
              if ( _answer == 'success' ) this.successCallback( 'Changes have been saved successfully!' );
              else this.global.defaultErrorCallback( _answer, false );
              this.getProjectPurchaseInfoData( );
          });
      });
  }


  trackByIndex ( index: number, obj: any ): any {
    return index;
  }

  createOptions ( ) {

    let _answer;
    let data = {
      message: 'Are you sure you want to create options for this project?',
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };


    this.global.confirmMessage( data, ( ) => {
      this.model.createOptions( this.id, ( response ) => {
        _answer = response.json( ).answer;
        if ( _answer == 'success' ) {
          this.successCallback( 'Options were created successfully' );
        } else this.global.defaultErrorCallback( _answer, false );
      });
    });

  }

  deleteProject ( ) {

    let _answer;
    let data = {
      message: 'Are you sure you want to delete this project?',
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };


    this.global.confirmMessage( data, ( ) => {
      this.model.deleteProject( this.id, ( response ) => {
        _answer = response.json( ).answer;
        if ( _answer == 'success' ) {
          this.successCallback( 'Project has been removed successfully' );
          setTimeout( ( ) => {
            this.global.redirect( '/' );
          }, 2500 );
        } else this.global.defaultErrorCallback( _answer, false );
      });
    });

  }

  removeSelectedProducts() {

    let _answer;
    let data = {
      message: 'Are you sure you want to remove selected products?',
      confirmButtonText: "Yes",
      cancelButtonText: "No"
    };


    this.global.confirmMessage( data, ( ) => {
      this.model.deleteLights( this.productsToRemove, ( response ) => {
        _answer = response.json( ).answer;
        if ( _answer == 'success' ) {
          this.successCallback( 'Products has been removed successfully' );
        } else this.global.defaultErrorCallback( _answer, false );
      });
    });
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/projects/project/project.component.ts